import React, { createContext, useContext, useState } from 'react';

const StripeContext = createContext();

export const useStripeContext = () => {
  const context = useContext(StripeContext);
  if (!context) {
    throw new Error('useStripeContext must be used within a StripeContextProvider');
  }
  return context;
};

export const StripeContextProvider = ({ children }) => {
  const [needsStripe, setNeedsStripe] = useState(false);

  const enableStripe = () => setNeedsStripe(true);
  const disableStripe = () => setNeedsStripe(false);

  return (
    <StripeContext.Provider value={{ needsStripe, enableStripe, disableStripe }}>
      {children}
    </StripeContext.Provider>
  );
};
